import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import type { IWarehouse, Nullable } from '@nova/core';
import checkoutService from '@/services/checkoutService';

const isLoading = ref<boolean>(true);
const warehouseData = ref<Nullable<Partial<IWarehouse>>>(null);

export function useWarehouseInfo() {
  const route = useRoute();
  const router = useRouter();

  const fetchAndStoreWarehouseInfo = async () => {
    try {
      const warehouseId = route.query.warehouseId as string;

      if (!warehouseId) {
        isLoading.value = false;
        await router.push({
          name: 'warehouse-error'
        });
        return;
      }

      const warehouseRequestData = await checkoutService.getWarehouseInformation(warehouseId);

      warehouseData.value = warehouseRequestData;
      isLoading.value = false;
    } catch (error) {
      isLoading.value = false;
      console.error('Error fetching warehouse information:', error);
      await router.push({
        name: 'warehouse-error'
      });
    }
  };

  return { fetchAndStoreWarehouseInfo, isLoading, warehouseData };
}
